import React from "react";
import PropTypes from "prop-types";
import LoginButtonContainer from "../../containers/login-button-container";
import ShoppingCart from "./shopping-cart";
import { GTranslate } from "../../services/g-translate/g-translate";
import GlobalSearch from "../search/global-search/global-search";


const componentMap = {
    "Search": GlobalSearch,
    "Translate": GTranslate,
    "View Cart": ShoppingCart,
    "Log In": LoginButtonContainer,
};
function IconNavContainer({ iconMenuList }) {
    if (iconMenuList && iconMenuList.length > 0) {

        return (
            <div className="d-flex align-items-center">
                {/*<GlobalSearch />*/}
                {/*<GTranslate />*/}
                {/*<ShoppingCart />*/}
                {/*<LoginButtonContainer isDrawer={false} />*/}

                {iconMenuList.map((item, index) => {
                    const IconComponent = componentMap[item.subheader];
                    return IconComponent ? (
                        <IconComponent key={index} iconMenu={item} isDrawer={item.subheader === "Log In" ? false : undefined} />
                    ) : null;
                })}

            </div>
        );
    }
    else return null;

}

export default IconNavContainer;

IconNavContainer.propTypes = {
    iconMenuList: PropTypes.array.isRequired,
};
